var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-checkbox-group",
    {
      attrs: { disabled: _vm.disabled },
      model: {
        value: _vm.mySelectedValue,
        callback: function ($$v) {
          _vm.mySelectedValue = $$v
        },
        expression: "mySelectedValue",
      },
    },
    _vm._l(_vm.Option, function (item) {
      return _c(
        "el-checkbox",
        { key: item.value, attrs: { label: item.value, value: item.value } },
        [_vm._v(_vm._s(item.name))]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }